<template>
  <div v-if="showHeadshotTile" class="flex flex-col">
    <router-link
      :to="{
        name: 'headshot',
        params: { applicationId: applicationId },
      }"
      class="flex flex-row justify-start items-center mb-2"
    >
      <CheckMarkIcon :completed="completed" />
      <p
        class="text-sm font-semibold ml-4 ml-4"
        :class="completed ? 'text-gray-650' : 'text-cyan-700'"
      >
        Headshot
      </p>
    </router-link>
  </div>
</template>

<script>
import CheckMarkIcon from "../SharedComponents/CheckMarkIcon.vue";
import formIoApi from "../../../mixins/formIoApi.js";
import postFormRules from "../../../mixins/postFormRules.js";
import { mapState } from "vuex";
import { eventBus } from "@/eventBus.js";

export default {
  name: "HeadshotCard",
  components: { CheckMarkIcon },
  mixins: [formIoApi, postFormRules],
  data() {
    return {
      formURL: "headshot",
    };
  },
  computed: {
    ...mapState(["program", "currentApplicationSubmissions"]),
    completed() {
      return Object.hasOwn(this.currentApplicationSubmissions, this.formURL);
    },
    applicationId() {
      return this.$route.params.applicationId;
    },
  },
  async mounted() {
    if (this.showHeadshotTile) {
      eventBus.$emit("addPreDepartureForm", {
        label: "Headshot",
        ruleName: "Head Shot",
        routeName: "headshot",
        submitted: this.completed,
      });
    }
  },
};
</script>
